import { cn } from "../../../lib/utils";

const LeadShimmerEffect = () => {
  return (
    <div className="space-y-4">
      {Array.from({ length: 10 }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "flex items-center justify-between p-4 border border-gray-200 rounded-lg bg-white animate-pulse"
          )}
        >
          {/* Profile Icon */}
          <div className="flex items-center space-x-4">
            <div className="w-10 h-10 bg-gray-300 md:h-8 ml-1 mr-1"></div>
            {/* Name and Email */}
            <div className="space-y-2">
              <div className="w-32 h-4 bg-gray-300 rounded"></div>
            </div>
            <div className="w-48 h-4 bg-gray-300 rounded"></div>
          </div>
          {/* Phone Number */}
          <div className="w-24 h-4 bg-gray-300 rounded"></div>
          {/* Placeholder for action buttons */}
          <div className="w-6 h-6 bg-gray-300 rounded"></div>
        </div>
      ))}
    </div>
  );
};

export default LeadShimmerEffect;
